// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

export const environment = {
    production: false,
    env: 'dev',
    apiUrlLocal: '',
    apiUrlV2: 'https://dev.digitaldealjacket.net/',
    videoSrcUrl: 'https://videos.digitaldealjacket.com/dev/',
    cognito: {
        UserPoolId: 'us-east-1_il50uhJU8',
        ClientId: '4i1cuj3ugu6nb0jq5hpjtk7h3b',
    },
    pdfTronKey: 'Unite Digital  LLC:OEM:Digital Deal Jacket::B+:AMS(20251107):8CCC0D43078A3AF37B313AC99263192F4E6F5F97666E900E9FCCC2142CC9A02ACA31F5C7',
    features: {
        apiSigning: true,
        defaultToMfa: true,
        licenseCaptureDiagnosticMode: true,
    },
};
